import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/organizations/mine';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation() {
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/organization/mine`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(unwrap(res)));
  } catch (error) {
    // Gating lookup — consumers decide whether a failure is user-visible
    // (Organization settings shows a snackbar; the members tab is silent).
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
